import { render, staticRenderFns } from "./Receber.vue?vue&type=template&id=443784b0&"
import script from "./Receber.vue?vue&type=script&lang=js&"
export * from "./Receber.vue?vue&type=script&lang=js&"
import style0 from "./Receber.vue?vue&type=style&index=0&id=443784b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports